// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"fd831b22308fcb5c9159","404":"0389ef48d90f3973c71c","406":"ed5f1a216d04469b2351"}[chunkId] + ".css";
};